import { useQuery } from '@tanstack/react-query'

import { caaMetricsInstance } from '../..'

export function getPatientCAAMetricsSemesterQueryKey(
  patientId: string,
  {
    personaName,
    period,
    year
  }: { personaName?: string; period: number; year: number }
) {
  return ['patientCAAMetricsSemester', patientId, { personaName, period, year }]
}

export function usePatientCAAMetricsSemesterQuery({
  patientId,
  personaName,
  period,
  year,
  enabled
}: {
  patientId: string
  personaName?: string
  period: number
  year: number
  enabled?: boolean
}) {
  return useQuery({
    queryKey: getPatientCAAMetricsSemesterQueryKey(patientId, {
      personaName,
      period,
      year
    }),
    queryFn: async () =>
      await caaMetricsInstance.getPatientCAAMetricsSemester({
        patientId,
        personaName,
        period,
        year
      }),
    enabled
  })
}
